import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11","key":"svg-0"}]]

/**
 * IconLetterU
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLXUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNHYxMWE1IDUgMCAwIDAgNSA1aDJhNSA1IDAgMCAwIDUgLTV2LTExIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/letter-u
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterU = createReactComponent('outline', 'letter-u', 'LetterU', __iconNode);

export default IconLetterU;